module.exports = __webpack_public_path__ + "media/icecrackone.8c08c490.mp3";